import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, AlertTriangleIcon, TrashIcon } from 'lucide-react';
export function DeleteAccount() {
  const [formState, setFormState] = useState({
    email: '',
    reason: '',
    confirmed: false
  });
  const [submitted, setSubmitted] = useState(false);
  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!formState.confirmed) return;
    const subject = encodeURIComponent(`Account Deletion Request — ${formState.email}`);
    const body = encodeURIComponent(`Account email: ${formState.email}\n\nReason (optional): ${formState.reason || 'Not provided'}\n\nI confirm that I want my Pawchi account and all associated data permanently deleted.`);
    window.location.href = `mailto:privacy@pawchi.app?subject=${subject}&body=${body}`;
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  }
  return <div className="min-h-screen bg-cream" data-id="element-853">
      <div className="max-w-2xl mx-auto px-6 pt-32 pb-20" data-id="element-854">
        <Link to="/" className="inline-flex items-center gap-2 text-warmBrown/60 hover:text-peach transition-colors mb-8 font-medium" data-id="element-855">
          <ArrowLeftIcon size={18} data-id="element-856" />
          Back to Home
        </Link>

        <h1 className="text-4xl md:text-5xl font-black text-warmBrown mb-3" data-id="element-857">
          Delete your account
        </h1>
        <p className="text-warmBrown/60 text-lg mb-10" data-id="element-858">
          Request the permanent deletion of your Pawchi account and all
          associated data.
        </p>

        {/* Warning callout */}
        <div className="bg-peach/10 border border-peach/30 rounded-2xl p-5 mb-8 flex gap-3" data-id="element-859">
          <AlertTriangleIcon size={22} className="text-peach flex-shrink-0 mt-0.5" data-id="element-860" />
          <div className="text-warmBrown/80 text-sm leading-relaxed" data-id="element-861">
            <p className="font-bold mb-2" data-id="element-862">This action is permanent.</p>
            <p className="mb-3" data-id="element-863">
              When your account is deleted, the following data will be
              permanently removed within 30 days:
            </p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-864">
              <li data-id="element-865">Your profile and account information</li>
              <li data-id="element-866">Your pet companions and their progress</li>
              <li data-id="element-867">All habit, mood, and breathing session history</li>
              <li data-id="element-868">Photos and any uploaded content</li>
              <li data-id="element-869">Settings and preferences</li>
            </ul>
            <p className="mt-3 text-warmBrown/60" data-id="element-870">
              Some anonymized data may be retained as required by law (e.g. for
              tax and audit purposes).
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5" data-id="element-871">
          <div data-id="element-872">
            <label htmlFor="email" className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-873">
              Account email
            </label>
            <input id="email" type="email" placeholder="The email associated with your Pawchi account" required value={formState.email} onChange={e => setFormState({
            ...formState,
            email: e.target.value
          })} className="w-full px-4 py-3 rounded-xl bg-white border border-warmBrown/10 text-warmBrown placeholder:text-warmBrown/30 focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors" data-id="element-874" />
          </div>

          <div data-id="element-875">
            <label htmlFor="reason" className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-876">
              Reason for leaving (optional)
            </label>
            <textarea id="reason" placeholder="Help us improve — let us know why you're deleting your account" rows={4} value={formState.reason} onChange={e => setFormState({
            ...formState,
            reason: e.target.value
          })} className="w-full px-4 py-3 rounded-xl bg-white border border-warmBrown/10 text-warmBrown placeholder:text-warmBrown/30 focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors resize-none" data-id="element-877" />
          </div>

          <label className="flex items-start gap-3 cursor-pointer p-4 rounded-xl bg-white border border-warmBrown/10 hover:border-warmBrown/20 transition-colors" data-id="element-878">
            <input type="checkbox" required checked={formState.confirmed} onChange={e => setFormState({
            ...formState,
            confirmed: e.target.checked
          })} className="mt-1 w-4 h-4 accent-peach" data-id="element-879" />
            <span className="text-sm text-warmBrown/80 leading-relaxed" data-id="element-880">
              I understand that this action is permanent and cannot be undone. I
              want my Pawchi account and all associated data to be deleted.
            </span>
          </label>

          <button type="submit" disabled={!formState.confirmed} className="px-8 py-4 rounded-full font-bold text-white bg-peach hover:bg-peach/90 disabled:bg-warmBrown/20 disabled:cursor-not-allowed transition-colors shadow-soft-lg flex items-center gap-2" data-id="element-881">
            {submitted ? 'Opening email client...' : <>
                <TrashIcon size={16} data-id="element-882" />
                Request account deletion
              </>}
          </button>
        </form>

        <p className="mt-8 text-sm text-warmBrown/50 leading-relaxed" data-id="element-883">
          You can also request deletion directly from within the app under{' '}
          <span className="font-medium text-warmBrown/70" data-id="element-884">
            Settings → Account → Delete account
          </span>
          . Requests are typically processed within 7 business days.
        </p>
      </div>
    </div>;
}